import { PoReviewDraft, PoReviewRow } from '../../redux/types';
import { ExtractionFinding } from '../../types';
import {
    hasLiveUnforcedConcern,
    isDateOutsideWindowFinding,
    LineItemsNotice,
    lineItemsNotice,
    submitConfirmationNotice,
} from './poReviewFindings';
import { SubmitBlocker, submitBlockers } from './poReviewValidation';

export type PoReviewFindingsByPlacement = {
    poNumberFindings: ExtractionFinding[];
    shipDateFindings: ExtractionFinding[];
    deliveryDateFindings: ExtractionFinding[];
    tableFindings: ExtractionFinding[];
};

export type PoReviewSubmitState = {
    blockers: SubmitBlocker[];
    flaggedRows: PoReviewRow[];
    confirmationNotice: LineItemsNotice;
    isScanned: boolean;
    showsPoNumberConcern: boolean;
    showsShipDateConcern: boolean;
    showsDeliveryDateConcern: boolean;
    shipDateQuotedValue?: string;
    deliveryDateQuotedValue?: string;
};

function headerConcernActive(hasConcern: boolean, currentValue: string, extractedValue: string | undefined): boolean {
    return hasConcern && extractedValue !== undefined && currentValue === extractedValue;
}

export function poReviewSubmitState(
    draft: PoReviewDraft,
    selectableLocationCodes: string[],
    findings: PoReviewFindingsByPlacement
): PoReviewSubmitState {
    return {
        blockers: submitBlockers(draft, selectableLocationCodes),
        flaggedRows: draft.rows.filter(hasLiveUnforcedConcern),
        confirmationNotice: submitConfirmationNotice(lineItemsNotice(findings.tableFindings)),
        isScanned: draft.plaintextAvailable === false,
        showsPoNumberConcern:
            !draft.poNumberRawValue &&
            headerConcernActive(findings.poNumberFindings.length > 0, draft.poNumber, draft.poNumberExtractedValue),
        showsShipDateConcern: headerConcernActive(
            findings.shipDateFindings.some(isDateOutsideWindowFinding),
            draft.shipDate,
            draft.shipDateExtractedValue
        ),
        showsDeliveryDateConcern: headerConcernActive(
            findings.deliveryDateFindings.some(isDateOutsideWindowFinding),
            draft.deliveryDate,
            draft.deliveryDateExtractedValue
        ),
        shipDateQuotedValue: draft.shipDatePrintedValue ?? draft.shipDateExtractedValue,
        deliveryDateQuotedValue: draft.deliveryDatePrintedValue ?? draft.deliveryDateExtractedValue,
    };
}
